import { createAction } from '@reduxjs/toolkit';

export const hideModal = createAction('HIDE_MODAL');

// need to call this like this showModal({type: 'MODAL_TYPE', props: {}})
export const showModal = createAction('SHOW_MODAL');
